import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  propertyDetails: {},
  graph: {},
  graphEvents: [],
  graphAlerts: [],
  total: 0,
  savedThresholdProfile: null,
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
